__turbopack_context__.v({
  "copyButton": "WalletSign-module__6GY0_q__copyButton",
  "description": "WalletSign-module__6GY0_q__description",
  "form": "WalletSign-module__6GY0_q__form",
  "header": "WalletSign-module__6GY0_q__header",
  "input": "WalletSign-module__6GY0_q__input",
  "loading": "WalletSign-module__6GY0_q__loading",
  "root": "WalletSign-module__6GY0_q__root",
  "signature": "WalletSign-module__6GY0_q__signature",
  "signatureContainer": "WalletSign-module__6GY0_q__signatureContainer",
  "title": "WalletSign-module__6GY0_q__title",
});
